import React, { useEffect, useState } from "react";
import { Dropdown, Tab, Nav, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import {
  get_HoroName,
  get_PrivacyPolicyDrp,
  get_PrivacyPolicySingleData,
  get_PrivacyPolicyData,
} from "../../../store/actions/CommanAction";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import DataTable from "react-data-table-component";
import swal from "sweetalert";
import { customStyles } from "../Utility/Utility";
import ReactQuill from "react-quill-new";
import Loader from "../Loader/Loader";

const PrivacyPolicy = () => {

  const dispatch = useDispatch();
  const customerID = Number(sessionStorage.getItem("ID"));

  const PrivacyPolicyData = useSelector((state) => state.feedBackReducer.PrivacyPolicyData);
  const PrivacyPolicySingleData = useSelector((state) => state.feedBackReducer.PrivacyPolicySingleData);
  const PrivacyPolicyDrpData = useSelector((state) => state.feedBackReducer.PrivacyPolicyDrpData);

  const [IsActive, setIsActive] = useState(true);
  const [postModal, setPostModal] = useState(false);
  const [contacts, setContacts] = useState(PrivacyPolicyData);
  const [EditValue, setEditValue] = useState();
  const [PrivacyPolicyID, setPrivacyPolicyID] = useState("");
  const [editModal, setEditModal] = useState(false);

  const [upDateCount, setUpDateCount] = useState(0);
  const [loading, setloading] = useState(false);

  const [addFormData, setaddFormData] = useState({
    Category: "",
    CreatedByUser: "1",
    PrivacyPolicys: "",
    PrivacyPolicyhtml: "",
  });

  useEffect(() => {
    if (IsActive) {
      dispatch(get_PrivacyPolicyData("1", setloading));
    } else {
      dispatch(get_PrivacyPolicyData("0", setloading));
    }
  }, [IsActive]);

  const Reset = () => {
    setaddFormData({
      ...addFormData,
      Category: "",
      PrivacyPolicys: "",
      PrivacyPolicyhtml: "",
    });
  };

  const ChangeDropDown = (e, name) => {
    setaddFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: e ? e.value : null,
      };
      return updatedData;
    });
  };

  
  const handleAddFormSubmit = async (e) => {
    let error = false;
    let errorMsg = "";
    if (addFormData.Category === "") {
      error = true;
      errorMsg = "Please fill Category.";
    }
    const existingCategory = Array.isArray(PrivacyPolicyData) ? PrivacyPolicyData.map((h) => h.Category) : [];
    if (existingCategory.includes(addFormData.Category)) {
      error = true;
      errorMsg = "Category already exists.";
    }
    if (error) {
      swal("Validation Error", errorMsg, "warning");
      return;
    }
    if (!error) {
      const formDataToSave = {
        ...addFormData,
        PrivacyPolicys: addFormData.PrivacyPolicys,
      };

      await AddUpdate("PrivacyPolicy/Insert_PrivacyPolicy", formDataToSave);
      swal("Good job!", "Successfully Updated", "success");
      dispatch(get_PrivacyPolicyData(IsActive, setloading));
      setPostModal(false);

    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  const UpdateCategory = async (e) => {
    e.preventDefault();
    let error = false;
    let errorMsg = "";
    if (addFormData.Category === "") {
      error = true;
      errorMsg = "Please fill Category.";
    }
    if (error) {
      swal("Validation Error", errorMsg, "warning");
      return;

    }
    if (!error) {
      await AddUpdate("PrivacyPolicy/Update_PrivacyPolicy", addFormData);
      swal("Good job!", "Successfully Updated", "success");
      dispatch(get_PrivacyPolicyData(IsActive, setloading));
      setEditModal(false);

    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  useEffect(() => {
    if (PrivacyPolicySingleData) {
      setEditValue(PrivacyPolicySingleData);
    }
  }, [PrivacyPolicySingleData]);

  useEffect(() => {
    setPrivacyPolicyID(PrivacyPolicyID);
    dispatch(get_PrivacyPolicySingleData(PrivacyPolicyID));
    dispatch(get_PrivacyPolicyDrp());
  }, [PrivacyPolicyID]);

  const handleEditClick = (row) => {
    setUpDateCount(upDateCount + 1);
    setPrivacyPolicyID(row?.PrivacyPolicyID);
    setEditModal(true);
  };

  useEffect(() => {
    if (EditValue && EditValue.length > 0) {
      setaddFormData({
        ...addFormData,
        PrivacyPolicyID: PrivacyPolicyID,
        Category: EditValue[0]?.Category,
        PrivacyPolicys: EditValue[0]?.PrivacyPolicys,
        PrivacyPolicyhtml: EditValue[0]?.PrivacyPolicyhtml,
      });
    }
  }, [EditValue]);

  const handleToggleStatusClick = async (
    PrivacyPolicyID,
    currentStatus,
    isActiveValue
  ) => {
    const postData = {
      PrivacyPolicyID: PrivacyPolicyID,
      DeleteByUser: customerID,
      IsActive: isActiveValue,
    };
    await AddUpdate("PrivacyPolicy/Delete_PrivacyPolicy", postData);
    dispatch(get_PrivacyPolicyData(currentStatus ? "1" : "0", setloading));
    swal(
      "Good job!",
      `Successfully ${isActiveValue === "1" ? "Active" : "Inactive"}`,
      "success"
    );
  };

  const columns = [
    {
      name: "Privacy/Policys",
      selector: (row) => row.PrivacyPolicys,
      sortable: true,
      format: (row) => (
        <>
          {row?.PrivacyPolicys ? row?.PrivacyPolicys.substring(0, 20) : ""}
          {row?.PrivacyPolicys?.length > 20 ? "  . . ." : null}{" "}
        </>
      ),
    },
    {
      name: "Category",
      selector: (row) => row.Category,
      sortable: true,
    },

    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <>
          <div style={{ position: "absolute", top: 4, right: 50 }}>
            <Dropdown>
              <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                <Dropdown.Item onClick={() => handleEditClick(row)}>
                  Edit
                </Dropdown.Item>
                <Dropdown.Item
                  className={row.IsActive ? "text-danger" : "text-success"}
                  onClick={() => {
                    handleToggleStatusClick(row.PrivacyPolicyID, true, "0");
                  }}
                >
                  Inactive
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
    // </td>
  ];

  const columns1 = [
    {
      name: "Privacy/Policys",
      selector: (row) => row.PrivacyPolicys,
      sortable: true,
      format: (row) => (
        <>
          {row?.PrivacyPolicys ? row?.PrivacyPolicys.substring(0, 20) : ""}
          {row?.PrivacyPolicys?.length > 20 ? "  . . ." : null}{" "}
        </>
      ),
    },
    {
      name: "Category",
      selector: (row) => row.Category,
      sortable: true,
    },

    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 0 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <>
          <div style={{ position: "absolute", top: 4, right: 5 }}>
            <Dropdown>
              <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                <Dropdown.Item
                  className={row.IsActive ? "text-danger" : "text-success"}
                  onClick={() => {
                    handleToggleStatusClick(row.PrivacyPolicyID, false, "1"); // Pass the new IsActive value
                  }}
                >
                  Active
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
  ];

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ header: 1 }, { header: 2 }, { header: 3 }],
      [{ font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ script: "sub" }, { script: "super" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      ["blockquote", "code-block"],
      ["link", "image", "video", "formula"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "script",
    "color",
    "background",
    "align",
    "list",
    "bullet",
    "indent",
    "blockquote",
    "code-block",
    "link",
    "image",
    "video",
  ];

  return (
    <>
      <Tab.Container defaultActiveKey="All">
        <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap">
          <div className="card-action coin-tabs ">
            <Nav as="ul" className="nav nav-tabs" role="tablist">
              <Nav.Item as="li" className="nav-item">
                <Nav.Link
                  className="nav-link"
                  eventKey="All"
                  onClick={(currentStatus) => {
                    setIsActive(true);
                  }}
                >
                  Active
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" className="nav-item">
                <Nav.Link
                  className="nav-link"
                  eventKey="Inactive"
                  onClick={(currentStatus) => {
                    setIsActive(false);
                  }}
                >
                  Inactive
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <Link
            to={"#"}
            className="btn btn-primary font-w600 "
            onClick={() => {
              setPostModal(true);
              Reset();
            }}
          >
            + New Policy
          </Link>
        </div>
        <div className="row ">
          <div className="col-xl-12">
            <div className="">
              <div className=" p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className="mb-sm-5 d-flex flex-wrap align-items-center text-head">
                      <Modal
                        className="modal fade"
                        size="xl"
                        show={postModal}
                        onHide={() => setPostModal(false)}
                        backdrop="static"
                      >
                        <form>
                          <div className="modal-header">
                            <h4 className="modal-title fs-20">Add Policy</h4>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setPostModal(false)}
                              data-dismiss="modal"
                            ></button>
                          </div>
                          <div className="modal-body p-3">
                            <i
                              className="flaticon-cancel-12 close"
                              data-dismiss="modal"
                            ></i>
                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <label className="form-label">
                                    Policy Name
                                  </label>
                                  <Select
                                    name="Category"
                                    value={
                                      PrivacyPolicyDrpData?.find(
                                        (obj) =>
                                          obj.value === addFormData?.Category
                                      ) || null
                                    }
                                    options={PrivacyPolicyDrpData}
                                    onChange={(e) =>
                                      ChangeDropDown(
                                        e,
                                        "Category",
                                        "HoroscopeName"
                                      )
                                    }
                                    placeholder="Select Status.."
                                    isClearable={true}
                                    // required
                                    required="required"
                                  />
                                </div>

                                <div className="form-group mt-4">
                                  <label className="form-label">
                                    Long Privacy/Policys
                                  </label>
                                  <div className="custom-ekeditor">
                                    <ReactQuill
                                      value={addFormData.PrivacyPolicyhtml}
                                      onChange={(value, delta, source, editor) => {
                                        const text = editor?.getText();
                                        setaddFormData((prevState) => ({
                                          ...prevState,
                                          PrivacyPolicyhtml: value,
                                          PrivacyPolicys: text,
                                        }));
                                      }}
                                      modules={modules}
                                      formats={formats}
                                      theme="snow"
                                      placeholder="Write something..."
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleAddFormSubmit}
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setPostModal(false);
                                Reset();
                              }}
                              className="btn btn-danger"
                            >
                              <i className="flaticon-delete-1"></i> Close
                            </button>
                          </div>
                        </form>
                      </Modal>
                    </div>
                    <Modal
                      className="modal fade "
                      size="xl"
                      show={editModal}
                      onHide={setEditModal}
                      backdrop="static"
                    >
                      <div className="" role="document">
                        <div className="">
                          <form>
                            <div className="modal-header">
                              <h4 className="modal-title fs-20">Edit Policy</h4>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setEditModal(false)}
                                data-dismiss="modal"
                              ></button>
                            </div>
                            <div className="modal-body p-3">
                              <i
                                className="flaticon-cancel-12 close"
                                data-dismiss="modal"
                              ></i>
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <label className="form-label">
                                    Policy Name
                                  </label>
                                  <Select
                                    name="Category"
                                    value={
                                      PrivacyPolicyDrpData?.find(
                                        (obj) =>
                                          obj.value === addFormData?.Category
                                      ) || null
                                    }
                                    options={PrivacyPolicyDrpData}
                                    onChange={(e) =>
                                      ChangeDropDown(
                                        e,
                                        "Category",
                                        "HoroscopeName"
                                      )
                                    }
                                    placeholder="Select Status.."
                                    isClearable={true}
                                    // required
                                    isDisabled
                                    required="required"
                                  />
                                </div>

                                <div className="form-group mt-4 ">
                                  <label className="form-label">
                                    Long Privacy/Policys
                                  </label>
                                  <div className="custom-ekeditor">
                                    <ReactQuill
                                      value={addFormData.PrivacyPolicyhtml}
                                      onChange={(value, delta, source, editor) => {
                                        const text = editor?.getText();
                                        setaddFormData((prevState) => ({
                                          ...prevState,
                                          PrivacyPolicyhtml: value,
                                          PrivacyPolicys: text,
                                        }));
                                      }}
                                      modules={modules}
                                      formats={formats}
                                      theme="snow"
                                      placeholder="Write something..."
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={UpdateCategory}
                              >
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setEditModal(false);
                                  Reset();
                                }}
                                className="btn btn-danger"
                              >
                                {" "}
                                <i className="flaticon-delete-1"></i> Close
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </Modal>
                    <div className="col-12 mt-2">
                      {loading ? (
                        <Loader />
                      ) : (
                        <DataTable
                          dense
                          data={PrivacyPolicyData}
                          columns={columns}
                          selectableRowsHighlight
                          // highlightOnHover
                          pagination
                          onRowClicked={(row) => {
                            // setClickedRow(row);
                            // set_Edit_Value(row);
                          }}
                          fixedHeader
                          persistTableHead={true}
                          noDataComponent={"There are no data to display"}
                          customStyles={customStyles}
                        />
                      )}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="Inactive">
                    <div className="row">
                      <div className="col-12 mt-2">
                        {loading ? (
                          <Loader />
                        ) : (
                          <DataTable
                            dense
                            data={PrivacyPolicyData}
                            columns={columns1}
                            selectableRowsHighlight
                            highlightOnHover
                            pagination
                            onRowClicked={(row) => {
                              // setClickedRow(row);   // set_Edit_Value(row);
                            }}
                            fixedHeader
                            persistTableHead={true}
                            noDataComponent={"There are no data to display"}
                            customStyles={customStyles}
                          />
                        )}
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};

export default PrivacyPolicy;
